(function () {
  var animationMs = 260;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setAnswerHeight(answer, height) {
    answer.style.height = height;
  }

  function getAnswerHeight(answer) {
    var inner = answer.querySelector('.product-faq__answer-inner');
    return (inner || answer).offsetHeight;
  }

  function clearItemTimer(item) {
    if (!item.productFaqTimer) return;
    window.clearTimeout(item.productFaqTimer);
    item.productFaqTimer = null;
  }

  function openItem(item, answer) {
    if (reduceMotion.matches || !answer) {
      item.open = true;
      return;
    }

    clearItemTimer(item);
    item.classList.add('is-animating', 'is-opening');
    answer.style.opacity = '0';
    setAnswerHeight(answer, '0px');
    item.open = true;

    requestAnimationFrame(function () {
      answer.style.opacity = '';
      setAnswerHeight(answer, getAnswerHeight(answer) + 'px');
    });

    item.productFaqTimer = window.setTimeout(function () {
      item.classList.remove('is-animating', 'is-opening');
      setAnswerHeight(answer, 'auto');
      item.productFaqTimer = null;
    }, animationMs);
  }

  function closeItem(item, answer) {
    if (reduceMotion.matches || !answer) {
      item.open = false;
      return;
    }

    clearItemTimer(item);
    item.classList.add('is-animating', 'is-closing');
    setAnswerHeight(answer, getAnswerHeight(answer) + 'px');

    requestAnimationFrame(function () {
      setAnswerHeight(answer, '0px');
    });

    item.productFaqTimer = window.setTimeout(function () {
      item.open = false;
      item.classList.remove('is-animating', 'is-closing');
      answer.style.height = '';
      item.productFaqTimer = null;
    }, animationMs);
  }

  function initFaq(section) {
    if (!section || section.dataset.productFaqInit === 'true') return;
    section.dataset.productFaqInit = 'true';

    section.querySelectorAll('[data-product-faq-item]').forEach(function (item) {
      var summary = item.querySelector('[data-product-faq-summary]');
      var answer = item.querySelector('[data-product-faq-answer]');

      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.classList.contains('is-animating')) return;

        if (item.open) {
          closeItem(item, answer);
        } else {
          openItem(item, answer);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-faq]').forEach(initFaq);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initFaq(event.target.querySelector('[data-product-faq]'));
  });
})();
